import React, { Fragment } from "react";
import { get_youtube_thumbnail } from "../../helpers/common";
import { useRouter } from "next/router";
import Image from "next/image";

const ImageCard = ({ resource, backgroundUrl, homePage, getResourceType }) => {
    const Router = useRouter();

    return (
        <Fragment>
            {resource.resource_type == 2 ? (
                <div
                    className="position-relative"
                    onClick={() => {
                        if (homePage) {
                            window.open(resource.resource_url, "_blank");
                        } else {
                            Router.push(`/resources/${resource?.id}`);
                        }
                    }}
                >
                    <div
                        role="button"
                        className="position-absolute top-0 start-0 bottom-0 end-0"
                        style={{
                            zIndex: 100
                        }}
                    />
                    <div className="badge-div ">
                        <div className="badge-item">
                            <span className="badge-styles">Slide</span>
                        </div>
                    </div>
                    <iframe
                        style={{ minHeight: "190px", maxHeight: "190px" }}
                        src={resource.resource_url}
                        allowFullScreen
                        frameBorder="0"
                    >
                        {" "}
                    </iframe>
                </div>
            ) : (
                <div
                    role="button"
                    onClick={
                        resource?.resource_type === 1
                            ? () => {
                                if (homePage) {
                                    window.open(resource.resource_url, "_blank");
                                } else {
                                    Router.push(`/resources/${resource.id}`);
                                }
                            }
                            : null
                    }
                >
                    <div
                        style={{
                            background:
                                resource.resource_type === 1
                                    ? `url(${get_youtube_thumbnail(
                                        resource.resource_url,
                                        backgroundUrl
                                    )})`
                                    : `url(${backgroundUrl})`,
                            backgroundSize: "cover"
                        }}
                        className="resouce-placeholder"
                    >
                        <div
                            style={{
                                background:
                                    resource.resource_type === 1
                                        ? `url(${get_youtube_thumbnail(
                                            resource.resource_url,
                                            backgroundUrl
                                        )})`
                                        : `url(${backgroundUrl})`,
                                backgroundSize: "cover"
                            }}
                            className="resouce-placeholder"
                        >
                            <div className="overlay p-4 pt-5">
                                <div className="badge-div ">
                                    <div className="badge-item">
                                        <span className="badge-styles">
                                            {getResourceType(resource.resource_type)}
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-auto play-btn-container">
                                    {resource.resource_type === 1 && (
                                        <Image
                                            width={50}
                                            height={50}
                                            src="/img/newplay.svg"
                                            alt="play"
                                            className="mb-3"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
					iframe {
						height: 100%;
						width: 100%;
						border-top-left-radius: 6px;
						border-top-right-radius: 6px;
					}

					.resouce-placeholder {
						width: 100%;
						height: 190px;
						display: flex;
						flex-direction: column;
						border-radius: 6px 6px 0px 0px;
						background-size: cover !important;
					}

					.overlay {
						position: relative;
						background: rgba(0, 46, 110, 0.32);
						border-radius: 6px;
						height: 100%;
						width: 100%;
						display: flex;
					}

					.badge-div {
						position: absolute;
						right: 20px;
						top: 15px;
					}
					.badge-item {
						display: flex;
						justify-content: center;
						align-items: center;
						background: rgba(225, 240, 255, 1);
						padding: 0px 8px 0px 8px;
						border-radius: 4px;
						font-weight: 500;
						font-size: 14px;
                        line-height: 21px;
					}
					.badge-styles {
						color: #002E6E;
					}
					.play-btn-container {
						height: 100%;
						width: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
					}
					
				`}</style>
        </Fragment>
    );
};

export default ImageCard;